import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { getAddressToDisplay, getValue } from 'core/utils';
import { ICustomerQuote } from 'quotes/types';

interface IProps {
  quote: ICustomerQuote;
}

export const ShipToInfo = ({ quote }: IProps) => {
  const { t } = useTranslation();

  return (
    <InfoCard
      title={t('titleShipTo')}
      items={[
        {
          value: [
            getValue(quote, 'shipToAddress.contactName'),
            getValue(quote, 'shipToAddress.contactPhone'),
          ],
        },
        {
          label: getValue(quote, 'shipToAddress.name') as string,
          value: getAddressToDisplay(quote?.shipToAddress),
        },
      ]}
    />
  );
};
